<script setup lang="ts">
import { defineProps, ref, onMounted  } from 'vue';
import moment from 'moment';
import { useEquipStore } from '~/store/equipStore';
import { useSiteStore } from '~/store/siteStore';
import { useTocStore } from '~/store/tocStore';

const props = defineProps<{
  apiData: any
}>();

const route = useRoute();
const router = useRouter();

const items = computed(() => props.apiData);

const equipStore = useEquipStore();
const tocStore = useTocStore();


const solarRadAmt = ref(null);

onMounted(async () => {
    if (props.apiData.solarRadAmt) {
        solarRadAmt.value = props.apiData.solarRadAmt;
    } else {
        try {
            const solarRadInfo = await tocStore.getSolarRadAmt(props.apiData.dongCode);
            if (solarRadInfo && solarRadInfo.length > 0 && solarRadInfo[0]) {
                solarRadAmt.value = solarRadInfo[0].solarRadAmt;
            } else {
                solarRadAmt.value = null;
            }
        } catch (error) {
            console.error('Error fetching solar radiation data:', error);
            solarRadAmt.value = null;
        }
    }
}) 

const engSource = ref();

if(route.fullPath.includes('equip')){
 engSource.value = equipStore.selectEquipInfo.engSource;
} else {
//  console.log(tocStore.selectSiteInfo.engSource);
 engSource.value = tocStore.selectSiteInfo.engSource;
}

// const engSource = computed(() => equipStore.selectEquipInfo.engSource);

</script>
<template>
    <div class="weather-info-card">
      <div class="row contents col-12" v-if="engSource === '10'">
        <div class="col-6 p-1 h-40">
            <div class="base-info-1 common-card" :style="{padding: '4px'}">
                <div class="base-info-1-wrapper">
                    <div>
                        <div class="key first">
                            일출
                        </div>
                        <div class="value">
                            {{ items?.sunrise != null ? items.sunrise : '-' }}
                        </div>
                    </div>
                    <div>
                        <div class="key second">
                            일몰
                        </div>
                        <div class="value">
                            {{ items?.sunset != null ? items.sunset : '-' }}
                        </div>
                    </div>
                </div>
                <div class="img_wrapper">
                    <img src="/assets/images/engSource-image/pv-image.png" width="100" height="50" />
                </div>
            </div>
        </div>
        <div class="col-3 p-1 h-40">
            <div class="base-info-2 common-card ml-1" :style="{padding: '8px'}">
            <div class="img-wrapper">
                <img src="@/assets/images/renewal/Sun.svg" style="filter: brightness(0) invert(1);" />
            </div>
            <!-- <div class="txt1">경사 일사량 </div>
            <div class="txt2">-</div> -->
            <div class="txt1">일사량</div>
            <!-- <div class="txt2">{{ '978.8 W/m2' }}</div> -->
            <div class="txt2">{{ (items?.solarRadAmt ?? solarRadAmt) != null ? (items?.solarRadAmt ?? solarRadAmt) + ' W/m2' : '-' }}</div>
            </div>

        </div>
        <div class="col-3 p-1 h-40">
            <div class="base-info-2 common-card delay-animation">
            <div class="img-wrapper">
                <img src="@/assets/images/renewal/Thermometer.svg" style="filter: brightness(0) invert(1);" />
            </div>
            <!-- <div class="txt1">모듈 온도</div>
            <div class="txt2">-</div> -->
            <div class="txt1">외기 온도</div>
            <div class="txt2">{{ items?.temp != null ? items.temp + ' °C' : '-' }}</div>
            </div>

        </div>
        <div class="col-6 p-1 h-40">
            <div class="base-info-3 common-card">
            <img :src="items?.iconPath || '/_nuxt/assets/images/renewal/Sun.svg'" />
            <div class="txt-wrapper">
                <div class="txt1">{{ items?.temp != null ? moment(items.fcstDate).format("hh:mm A") : '-' }}</div>
                <div class="txt2">{{ items?.temp != null ? items.temp + ' °C' : '-' }}</div>
            </div>
            </div>
        </div>

        <div class="col-3 p-1 h-40">
            <div class="base-info-4 common-card rain-card ml-1">
                <img src="@/assets/images/renewal/rain.svg" style="filter: brightness(0) invert(1);" />
                <div class="d-flex flex-column align-items-center">
                    <div class="txt1">강수 확률</div>
                    <div class="txt2">{{ items?.rainProb != null ? items.rainProb + ' %' : '-' }}</div>
                </div>
            </div>
        </div>

        <div class="col-3 p-1 h-40">
            <div class="base-info-4 common-card water-card">
                <img src="@/assets/images/renewal/water.svg" style="filter: brightness(0) invert(1);" />
                <div class="d-flex flex-column align-items-center">
                    <div class="txt1">습도</div>
                    <div class="txt2">{{ items?.humidity != null ? items.humidity + ' %' : '-' }}</div>
                </div>
            </div>

        </div>
      </div>
      <div class="row contents col-12" v-if="engSource === '20'">
        <div class="col-6 p-1 h-100 d-flex align-items-center">
            <img src="@/assets/images/renewal/solar_sample.png" width="100%" height="100%" />
        </div>
        <div class="row col-6 h-100">
            <div class="col-12 p-1 h-40">
                <div class="base-info-3 common-card">
                <img :src="items?.iconPath || '/_nuxt/assets/images/renewal/Sun.svg'" />
                <div class="txt-wrapper">
                    <div class="txt1">{{ items?.temp != null ? moment(items.fcstDate).format("hh:mm A") : '-' }}</div>
                    <div class="txt2">{{ items?.temp != null ? items.temp + ' °C' : '-' }}</div>
                </div>
                </div>
            </div>
            <div class="col-6 p-1 h-60">
                <div class="base-info-4 common-card rain-card">
                    <img src="@/assets/images/renewal/rain.svg" style="filter: brightness(0) invert(1);" />
                    <div class="d-flex flex-column align-items-center">
                        <div class="txt1">강수 확률</div>
                        <div class="txt2">{{ items?.rainProb != null ? items.rainProb + ' %' : '-' }}</div>
                    </div>
                </div>

            </div>
            <div class="col-6 p-1 h-60">
                <div class="base-info-4 common-card water-card">
                    <img src="@/assets/images/renewal/water.svg" style="filter: brightness(0) invert(1);" />
                    <div class="d-flex flex-column align-items-center">
                        <div class="txt1">습도</div>
                        <div class="txt2">{{ items?.humidity != null ? items.humidity + ' %' : '-' }}</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="row contents col-12" v-if="engSource === '30'">
        <div class="col-6 p-1 h-100 d-flex align-items-center">
            <img src="@/assets/images/renewal/geo_sample.png" width="100%" height="100%" />
        </div>
        <div class="row col-6 h-100">
            <div class="col-12 p-1 h-40">
                <div class="base-info-3 common-card">
                <img :src="items?.iconPath || '/_nuxt/assets/images/renewal/Sun.svg'" />
                <div class="txt-wrapper">
                    <div class="txt1">{{ items?.temp != null ? moment(items.fcstDate).format("hh:mm A") : '-' }}</div>
                    <div class="txt2">{{ items?.temp != null ? items.temp + ' °C' : '-' }}</div>
                </div>
                </div>
            </div>
            <div class="col-6 p-1 h-60">
                <div class="base-info-4 common-card rain-card">
                    <img src="@/assets/images/renewal/rain.svg" style="filter: brightness(0) invert(1);" />
                    <div class="d-flex flex-column align-items-center">
                        <div class="txt1">강수 확률</div>
                        <div class="txt2">{{ items?.rainProb != null ? items.rainProb + ' %' : '-' }}</div>
                    </div>
                </div>

            </div>
            <div class="col-6 p-1 h-60">
                <div class="base-info-4 common-card water-card">
                    <img src="@/assets/images/renewal/water.svg" style="filter: brightness(0) invert(1);" />
                    <div class="d-flex flex-column align-items-center">
                        <div class="txt1">습도</div>
                        <div class="txt2">{{ items?.humidity != null ? items.humidity + ' %' : '-' }}</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/weather-info-card.scss";
@use "@/assets/styles/design-toc/define_font.scss";
@use "@/assets/styles/design-toc/common-card.scss";

.p-1 {
    padding: 0.125rem !important;
}

.col-3 {
    padding: 0.125rem !important;
}
.ml-1 {
    margin-left: 0.125rem !important;
}
</style>